// extracted by mini-css-extract-plugin
export var container = "_bj-1";
export var cornerButtonContainer = "_bj-5";
export var disabled = "_bj-2";
export var fileContainer = "_bj-4";
export var hiddenInput = "_bj-3";
export var widthContainer = "_bj-0";